import HttpService from './HttpService'

const _http = new HttpService()
export default {
  show: (page, options = null) => {
    let _parans = `?page=${page - 1}`;
    if (options) {
      if(options.search) {
        _parans += `&search=${options.search}`;
      }
      if (options.orderByKey) {
        _parans += `&order_by=${options.orderByKey}`
      }
      if (options.ascOrDes) {
        _parans += '&asc'
      }
    }
    return _http.get(`/api/permission-group${_parans}`)
  },
  showAll: () => {
    return _http.get(`/api/permission-group/all`)
  },
  showPermissions: () => {
    return _http.get(`/api/permission-group/permissions`)
  },
  find: (id) => {
    return _http.get(`/api/permission-group/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/permission-group', payload)
  },
  update: (payload) => {
    return _http.put('/api/permission-group', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/permission-group/${id}`)
  },
  autoComplete: (search) => {
    return _http.get(`/api/permission-group/autocomplete-permissions?page=${0}&search=${search}&asc`)
  },
}